import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';
import { format_date } from '../../../Utils/Dateutils';
import axios from 'axios';

const TableBody = ({
    serialNumber,
    id,
    entrydate,
    fromdt,
    todt,
    empId,
    empNm,
    work_type,
    work_hrs,
    totdays,
    present_days,
    leave_days,
    leave_amt,
    perHr_amt,
    perDay_amt,
    amt,
    dedamt,
    totamt,
    extra_hrs,
    extrahrs_amt,
    narr,
    sts,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;

    const handleDeleteClick = () => {
        // Show confirmation dialog

        const isConfirmed = window.confirm("you want to delete this Fixed Employee Jobwork?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            deleteFixedEmpJobworkApi(id, userdata?.ID);
        }


    };

    const deleteFixedEmpJobworkApi = async (id, userId) => {
        try {
            const res = await axios.delete(`${baseUrl}?apicall=deleteFixedEmployeeJobwork&fixId=${id}&userId=${userId}`);
            console.log("deleteresponse=>",res);
            if (res.status === "success") {
                alert("Data Deleted Successfully...!!!");            // "Data Deleted Successfully."
                window.location.reload();
            } else {
                // msg can be array or string
                const msg = Array.isArray(res.data.msg) ? res.data.msg.join("\n") : res.data.msg;
                alert(msg);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleViewClick = () => {
        window.open(`/fixed-emp-jobwork-print/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handlePendingClick = () => {
        window.open(`/payment-entry/${id}`, '_blank', 'width=900,height=600,scrollbars=yes,resizable=yes');
    };


    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        // window.open(`/ClothIssueEdit/${id}`, '_blank', 'width=1100,height=800,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {entrydate}
                </TableCell>


                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {`${fromdt} - ${todt}`}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {empNm}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {work_type}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {work_hrs}
                </TableCell>


                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {totdays}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {present_days}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {leave_days}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {Math.round(leave_amt)}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {perHr_amt}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {perDay_amt}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {extra_hrs}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {Math.round(extrahrs_amt)}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {Math.round(amt)}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {Math.round(dedamt)}
                </TableCell>
                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {Math.round(totamt)}
                </TableCell>
                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {narr}
                </TableCell>

                {/* <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {payableamt}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {pay_sts === '1' ? <span style={{ color: 'green', fontWeight: 'bold' }}>Paid</span> : <Button variant="contained" color="warning" size='small' onClick={handlePendingClick}>Pending</Button>}
                </TableCell> */}

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    <DeleteIcon className={`cursor-pointer `} onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
